import { MailDomain, TransactionalMailSmtpUser } from "../../../lib/src/api/partner/models/MailDomain";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC } from "react";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const DeleteTransactionalMailUserModal: FC<{ domain: MailDomain, user: TransactionalMailSmtpUser }> = ({ domain, user }) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const reload = useRefresh()

  const confirm = async () => {
    const deployment = await partnerClient.deleteUserFromTransactionalMailDomain(domain.id, user.id).then(result => {
      if (!result.success) {
        throw new Error(result.error)
      }
      return result.data
    })
    await awaitNextDeploymentFinished(deployment.id)
    reload()
  }
  return <>
    <p className={""}>
      <strong>Caution!</strong> You are about to delete the credential <strong>{user.emailAddress}</strong> from this domain.
    </p>
    <ModalFooter icon={faTrash} text={"Delete"} onSubmit={confirm} />
  </>
}
